import type { IMatchScheduleItem, ITournamentSchedule } from '../../types/schedule';
import { deepCloneSerializable } from '../../utils/deepCloneSerializable';

/** Max undo steps kept in memory for large tournaments */
export const MAX_SCHEDULE_HISTORY = 40;

export type ScheduleHistorySnapshot = {
    schedule: ITournamentSchedule | null;
    unscheduledMatches: IMatchScheduleItem[];
};

/** Deep clone — prefers structuredClone (faster than JSON on large trees); JSON fallback for older runtimes. */
export function cloneScheduleSnapshot(snapshot: ScheduleHistorySnapshot): ScheduleHistorySnapshot {
    return deepCloneSerializable(snapshot);
}

export function snapshotScheduleState(
    schedule: ITournamentSchedule | null,
    unscheduledMatches: IMatchScheduleItem[]
): ScheduleHistorySnapshot {
    return cloneScheduleSnapshot({ schedule, unscheduledMatches });
}
